// @ vendors
const { APIGet } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const {formatText } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
const { BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER,
        SPAIN_PLANS_UNIVERSE_ID
    } = require('constants/index');
// @ actions
const { searchSpecificIsin } = require('actions/brokerProductAdvancedSearch');

const requestPensionPlanNotFound = () => ({
    type: actionTypes.FETCH_BROKER_PENSION_PLAN_NOT_FOUND,
    payload: {
        error: formatText('brokerHireInvestmentStep1-nonExistingFund')
    }
});

const reset = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_RESET
});

const requestPensionPlanInProgress = () => ({
    type: actionTypes.FETCH_BROKER_PENSION_PLAN_REQUEST
});

const requestPensionPlanSuccess = (data, response) => ({
    type: actionTypes.FETCH_BROKER_PENSION_PLAN_SUCCESS,
    payload: {
        pensionPlans: data,
        securityDetails: response
    }
});

const requestPensionPlanFailure = (error) => ({
    type: actionTypes.FETCH_BROKER_PENSION_PLAN_FAILURE,
    payload: {
        error
    }
});

const getPensionPlanDetails = (data) => (dispatch, getState) => {
    const typeId = BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER;

    const requestData = {
            query: {
                viewId: 'fullNew',
                LanguageId: 'es-ES',
                responseViewFormat: 'json'
            }
    }
    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', {type:typeId, id:data.rows[0].SecId}), requestData)
        .then( response => {
            dispatch(requestPensionPlanSuccess(data, response));
        })
        .then( () => {
            const immBrokerPensionPlans = getState().brokerPensionPlans;
            const dgsCode = immBrokerPensionPlans.getIn(['pensionPlan', 'dgscode']);
            dispatch(searchSpecificIsin(dgsCode, true));
        })
        .catch(response => {
            if (response.error) {
                dispatch(requestPensionPlanFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const requestPensionPlan = (product) => (dispatch, getState) => {
    const immPensionPlans = getState().brokerPensionPlans;

    if (!immPensionPlans.get('isFetching')) {
        const typeId = BROKER_INVESTMENT_PLANS_PRODUCT_URL_PARAMETER;

        const requestData = {
            query: {
                securityDataPoints:'SecId|ISIN|Name|CustomCategoryIdName|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit|CustomMinimumAdditionalPurchaseAmount|CustomMinimumAdditionalPurchaseAmountUnit|CustomInstitutionSecurityId|ReturnM0|DGSCode|CustomValue1|CustomValue2|CustomValue3|CustomValue4',
                pageSize:5000,
                outputType:'json',
                languageId:'es-ES',
                currencyId:'EUR',
                universeIds: SPAIN_PLANS_UNIVERSE_ID,
                filters:`CustomInstitutionSecurityId:EQ:${product}`
            }
        };

        dispatch(requestPensionPlanInProgress());
        return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreener', {type: typeId}), requestData)
            .then(response => {
                (!!response.rows.length) ?
                dispatch(getPensionPlanDetails(response)) :
                dispatch(requestPensionPlanNotFound())})
            .catch(response => {
            if (response.error) {
                dispatch(requestPensionPlanFailure(response.error.description));
            } else {
                throw response;
            }
        });
    }
};

module.exports = {
    requestPensionPlan,
    reset
};
